import { apiRequest } from './httpClient';

export const getMetaLeadAdsConnection = () => apiRequest('getMetaLeadAdsConnection', {
  method: 'GET',
});

export const saveMetaLeadAdsConnection = (payload) => apiRequest('saveMetaLeadAdsConnection', {
  method: 'POST',
  body: payload,
});
